import { Pipe, PipeTransform } from '@angular/core';
import { PrefixService } from '../services/prefix.service';

@Pipe({name: 'toSAPPartNumber'})
export class ToSAPPartNumberPipe implements PipeTransform {
  constructor(private prefixService: PrefixService){}
  oldSymbolPrefixes: string[] = ['$', '%', '^', '&', '='];
  newPrefixes: string[] = ['C_', 'T_', 'B_', 'W_', 'S_', 'P_'];

  transform(value: string): string {
    let partNo = value;
    const firstTwoCharactersOfSearch = partNo.slice(0,2);

    if (this.newPrefixes.indexOf(firstTwoCharactersOfSearch.toUpperCase()) != -1) {
      if(this.newPrefixes.indexOf(firstTwoCharactersOfSearch) != -1) {   
        this.prefixService.changeProductPrefix(firstTwoCharactersOfSearch);
        partNo = this.replaceAllFunction(partNo);
        return partNo;
      } else {
        return firstTwoCharactersOfSearch.toUpperCase() + partNo.slice(2)
      }
    } else {
      let firstCharacterOfSearch = partNo[0];

      if (this.oldSymbolPrefixes.indexOf(firstCharacterOfSearch) != -1) {
        this.replaceSymbolWithPrefix(firstCharacterOfSearch);
        partNo = partNo.slice(1);
        partNo = this.replaceAllFunction(partNo);

        return this.prefixService.selectedProductPrefix.getValue() + partNo;
      } else {
        partNo = this.replaceAllFunction(partNo);

        return this.prefixService.selectedProductPrefix.getValue() + partNo;
      }
    }
  }

  replaceAllFunction(input: any) {
    input = input.replaceAll('*', '_A');
    input = input.replaceAll('#', '_O');
    input = input.replaceAll('+', ':');
    return input;
  }

  replaceSymbolWithPrefix(input: any) {
    if (input === '$') {
      this.prefixService.changeProductPrefix('C_');
    } else if (input === '%') {
      this.prefixService.changeProductPrefix('T_');
    } else if (input === '^') {
      this.prefixService.changeProductPrefix('B_');
    } else if (input === '&') {
      this.prefixService.changeProductPrefix('W_');
    } else if (input === '=') {
      this.prefixService.changeProductPrefix('S_');
    }
  }
}